export enum CustomFormSignatureType {
    TARGET_USER = 0,
    SUPERVISOR = 1,
    ADMIN = 2
}